// element dispatching the events
export const eventsRootEl = document.getElementById('portal');

// These events will notify client apps (currently just wagering) when the portal app logged in/out,
// so the clients can request a client token for themselves
const EVENT_PORTAL_LOGGED_IN = 'login';
const EVENT_PORTAL_LOGGED_OUT = 'logout';

export const dispatchLogin = () => eventsRootEl?.dispatchEvent(new Event(EVENT_PORTAL_LOGGED_IN));

export const dispatchLogout = () => eventsRootEl?.dispatchEvent(new Event(EVENT_PORTAL_LOGGED_OUT));

// This event will be fired when an api call will have status 401 Unauthorized,
// PortalsessionContext is listening for them and behaving accordingly

export const UNAUTHORIZED_API = 'unauthorized_api';

export const dispatchUnauthorizedApi = (unauthResponse: UnauthorizedResponse) =>
	eventsRootEl?.dispatchEvent(
		new CustomEvent(UNAUTHORIZED_API, { detail: { tokenStatus: unauthResponse?.meta?.token_status } })
	);

const EVENT_PORTAL_USER_BALANCE_CHANGED = 'user_balance_changed';

export const dispatchUserBalanceUpdate = (balance: number) =>
	eventsRootEl?.dispatchEvent(new CustomEvent(EVENT_PORTAL_USER_BALANCE_CHANGED, { detail: { balance } }));

const BETTING_APP_MOUNT = 'betting_app_mount';

export const dispatchBettingAppMount = (mounted: boolean) =>
	eventsRootEl?.dispatchEvent(new CustomEvent(BETTING_APP_MOUNT, { detail: { mounted } }));

const FANTASY_APP_MOUNT = 'fantasy_app_mount';

export const dispatchFantasyAppMount = (mounted: boolean) =>
	eventsRootEl?.dispatchEvent(new CustomEvent(FANTASY_APP_MOUNT, { detail: { mounted } }));

export const USER_ACTIVITY_HEARTHBEAT = 'user_activity_hearthbeat';

export const dispatchUserActivity = () => eventsRootEl?.dispatchEvent(new CustomEvent(USER_ACTIVITY_HEARTHBEAT));

export const EVENT_PORTAL_GEOCOMPLY_UPDATE = 'geocomply_update';

export const dispatchGeocomplyUpdate = () =>
	eventsRootEl?.dispatchEvent(new CustomEvent(EVENT_PORTAL_GEOCOMPLY_UPDATE));

export const EVENT_PORTAL_PUSH_URL = 'push_url';

export const dispatchPushUrl = (url) =>
	eventsRootEl?.dispatchEvent(new CustomEvent(EVENT_PORTAL_PUSH_URL, { detail: { url } }));
